import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { TLngLat } from 'App/Map/types'
import { Button } from 'components/Button/Button'
import { translate } from 'i18n/i18n'
import type { Dispatch, SetStateAction } from 'react'
import { apiFetch } from 'utils/apiFetch'
import { showNotification } from 'utils/showNotification'

export const RemoveOverridesButton = ({
  isDeleting,
  selectedStation,
  setIsDeleting,
  setFc,
  setPwp,
  setOverrides,
}: {
  isDeleting: boolean
  selectedStation: TLngLat | null
  setIsDeleting: Dispatch<SetStateAction<boolean>>
  setFc: Dispatch<SetStateAction<number | ''>>
  setPwp: Dispatch<SetStateAction<number | ''>>
  setOverrides: Dispatch<SetStateAction<routes.SoilCalibrationSettingsGet.Response['overrides']>>
}) => {
  return (
    <Button
      css={{ marginTop: 12 }}
      loading={isDeleting}
      onClick={async () => {
        if (!selectedStation) return

        try {
          setIsDeleting(true)

          const response = await apiFetch({
            url: '/soil-calibration-settings-delete',
            body: { lngLat: selectedStation },
          })

          if (response === false) {
            throw new Error('Failed to update the soil moisture calibration.')
          }

          setFc('')

          setPwp('')

          setOverrides({})

          showNotification({
            type: 'success',
            message: translate.phrases.banyanApp('Successfully removed overrides for this station'),
          })
        } catch (err) {
          showNotification({
            type: 'error',
            message: translate.phrases.banyanApp('Failed to remove overrides for this station'),
          })
        } finally {
          setIsDeleting(false)
        }
      }}
    >
      {translate.phrases.banyanApp('Remove all FC/PWP overrides for each sensor of this station')}
    </Button>
  )
}
